var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.setModal()}}},[_c('a',{staticClass:"call-to-action",attrs:{"href":_vm.returnLink()}},[_vm._v(" "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }